<template>
  <!-- 盒子 -->
  <div class="box-div" :class="`entrantsType${entrantsType}`">
    <img v-if="imgList.img && ifImg" class="tui-img" :src="imgList.img" alt="">

    <div class="zychoice">
      <!-- 选择xueyuan -->
      <!-- <div class="zychoiceTop" v-if="showSchool">
        <div class="zychoiceTopLeft">全部学院：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" @click="schoolClick()" :class="[!search.school ? 'on' : '']">全部</div>
          <div
            class="right-item"
            @click="schoolClick(item)"
            v-for="(item, ina) in schoollist"
            :key="ina"
            :class="search.school == item.pKind ? 'on' : ''"
          >
            {{ item.pName }}
          </div>
        </div>
      </div> -->
      <!-- 选择项目 -->
      <!-- v-if="(showSchool && search.school) || !showZy" -->
      <div class="zychoiceTop">
        <div class="zychoiceTopLeft">全部项目：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" :class="[!search.kind ? 'on' : '']" @click="kindClick()">全部</div>

          <div v-for="(item, ina) in majorList" :key="ina" class="right-item"
            :class="search.kind == item.pKind ? 'on' : ''" @click="kindClick(item)">
            {{ item.pName }}
          </div>
        </div>
      </div>
      <!-- 选择层次 -->
      <div v-if="search.kind && stageList.length > 0 && showLevel && search.examType != 2 && !isXiaoQingWang"
        class="zychoiceTop">
        <div class="zychoiceTopLeft">{{ zStage }}：</div>
        <div class="zychoiceTopRight">
          <!-- 自考专升本不展示全部 -->
          <div v-if="search.kind !== 1" class="right-item" :class="[search.stage == '全部' ? 'on' : '']"
            @click="stageChoose()">
            全部
          </div>

          <div v-for="(item, inb) in stageList" :key="inb" class="right-item"
            :class="[search.stage == item.stage ? 'on' : '']" @click="stageChoose(item)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <!-- 选择专业 -->
      <div v-if="search.kind && showZy && search.examType != 2" class="zychoiceTop">
        <div class="zychoiceTopLeft">{{ kindZyName }}：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" :class="[!search.zyId ? 'on' : '']" @click="zyChoose()">全部</div>

          <div v-for="(item, inb) in zylist" :key="inb" class="right-item"
            :class="[search.zyId == item.zId ? 'on' : '']" @click="zyChoose(item)">
            {{ item.zName }}
          </div>
        </div>
      </div>
      <!-- 专业课程 -->
      <!-- <div v-if="search.zyId && showKc" class="zychoiceTop">
        <div class="zychoiceTopLeft">全部课程：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" :class="[!search.kcId ? 'on' : '']" @click="kcChoose()">全部</div>
          <div v-for="(item, index) in kcList" :key="index" class="right-item"
            :class="[search.kcId == item.kid ? 'on' : '']" @click="kcChoose(item)">
            {{ item.keName }}
          </div>
        </div>
      </div> -->
      <!-- 班型 -->
      <div v-if="type == 15 && classesFenlei.length > 0" class="zychoiceTop">
        <div class="zychoiceTopLeft">选择类型：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" :class="[search.productLine == 4 ? 'on' : '']" @click="classTypeChoose()">
            全部
          </div>
          <div v-for="item in classTypeList" v-show="classesFenlei.includes(item.value)" :key="item.value"
            class="right-item" :class="search.productLine == item.value ? 'on' : ''" @click="classTypeChoose(item)">
            {{ item.label }}
          </div>
        </div>
      </div>
      <!-- 课程 -->
      <div v-if="type == 117 && classesFenlei.length > 0" class="zychoiceTop">
        <div class="zychoiceTopLeft">选择类型：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" :class="[search.productLine == 4 ? 'on' : '']" @click="courseTypeChoose()">
            全部
          </div>
          <div v-for="item in courseTypeList" v-show="classesFenlei.includes(item.value)" :key="item.value"
            class="right-item" :class="search.productLine == item.value ? 'on' : ''" @click="courseTypeChoose(item)">
            {{ item.label }}
          </div>
        </div>
      </div>
      <!-- 试卷/试卷包 -->
      <div v-if="(type == 7 || type == 1 || type == 12) && entrantsType == 3" v-show="classfiList.length > 0"
        class="zychoiceTop">
        <div class="zychoiceTopLeft">选择分类：</div>
        <div class="zychoiceTopRight">
          <div class="right-item" :class="[!search.type ? 'on' : '']" @click="clas()">全部</div>
          <div v-for="(item, index) in classfiList" v-show="item.fName != '随堂练习'" :key="index" class="right-item"
            :class="[search.type == item.fId ? 'on' : '']" @click="clas(item)">
            {{ item.fName }}
          </div>
        </div>
      </div>
      <div v-if="type == 7 && entrantsType == 3 && (testPaperPack || testPaper)" class="zychoiceTop">
        <div class="zychoiceTopLeft">选择类型：</div>
        <div class="zychoiceTopRight">
          <div v-if="testPaperPack" class="right-item" :class="[search.examType == 1 ? 'on' : '']" @click="exam(1)">
            试卷包
          </div>
          <div v-if="testPaper" class="right-item" :class="[search.examType == 2 ? 'on' : '']" @click="exam(2)">
            试卷
          </div>
        </div>
      </div>
    </div>
    <!-- 试卷/试卷包 -->
    <div v-if="(type == 7 || type == 1 || type == 12) && entrantsType == 2" class="tabBox dis_flex_between m-t-40">
      <div v-show="classfiList.length > 0" class="list">
        <div class="item" :class="[!search.type ? 'on' : '']">
          <div class="item-title" @click="clas()">全部</div>
        </div>
        <div v-for="(item, index) in classfiList" v-show="item.fName != '随堂练习'" :key="index" class="dis_flex item"
          :class="[search.type == item.fId ? 'on' : '']">
          <!-- v-if="index > 0" -->
          <el-divider direction="vertical" />
          <div class="item-title" @click="clas(item)">{{ item.fName }}</div>
        </div>
      </div>
      <el-radio-group v-if="type == 7 && (testPaperPack || testPaper)" v-model="search.examType"
        class="redRadio fles-shrink" @change="changeList">
        <el-radio v-if="testPaperPack" :label="1">试卷包</el-radio>
        <el-radio v-if="testPaper" :label="2">试卷</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
import referenceFilter from "@/components/kindChooseViewzl.vue";
import { HomeClient } from "@/api/home";
import request from "@/common/utils/request.js";
const homeClient = new HomeClient();

export default {
  props: { ...referenceFilter.props, ifImg: { type: Boolean, default: true } },
  data() {
    return { ...referenceFilter.data.call(this), majorList: [], isXiaoQingWang: false };
  },
  watch: {
    zylist(newVal, oldVal) {
      if (newVal === oldVal) return;
      if (this.search.kind == 1) {
        // 接口已按请求层次筛选；未返回层次的专业不能再次被前端剔除。
        const rows = newVal.filter((item) => !item.zStage || item.zStage === "专升本");
        if (rows.length !== newVal.length) this.zylist = rows;
      }
    },
  },
  async created() {
    if (this.testPaperType) this.search.type = this.testPaperType;
    this.isXiaoQingWang = localStorage.getItem("isXiaoQingWang") || false;
    await Promise.all([
      homeClient.getSurfacePcList({ type: 4, entrantsType: this.entrantsType }).then((res) => {
        if (res.code == 0) this.imgList = (res.data || res.msg || [])[0] || {};
      }),
      this.getKind(),
    ]);
    await this.getMaterialClass();
    if (this.kind) {
      const item = this.majorList.find((project) => project.pKind == this.kind);
      if (item) await this.kindClick(item);
    }
    if (this.zyId) {
      const item = this.zylist.find((major) => major.zId == this.zyId);
      if (item) this.zyChoose(item);
    }
  },
  methods: {
    ...referenceFilter.methods,
    // 参照接口返回学院及其项目，原页面直接展示项目，因此展开并按项目编号去重。
    async getKind() {
      const res = await homeClient.getTenantLearnMaterialsZyList();
      this.schoollist = res.code == 0 && Array.isArray(res.data) ? res.data : [];
      const projects = [];
      const projectIds = new Set();
      this.schoollist.forEach((school) => {
        const rows = Array.isArray(school.kindList) ? school.kindList : [school];
        rows.forEach((project) => {
          if (project.pKind === undefined || project.pKind === null || projectIds.has(String(project.pKind))) return;
          projectIds.add(String(project.pKind));
          projects.push(project);
        });
      });
      this.majorList = projects;
      this.kindList = projects;
    },
    getMaterialClass() {
      return homeClient.getDataList({ code: "materialType" }).then((res) => {
        this.classfiList = (res.data || []).map((item) => ({
          ...item, fId: item.key, fName: item.value,
        })).filter((item) => item.fName !== "随堂练习");
        this.getLIst();
      });
    },
    getTabList() {
      return this.getMaterialClass();
    },
    async kindClick(item) {
      if (!item) {
        referenceFilter.methods.kindClick.call(this);
        this.kcList = [];
        return;
      }
      this.search.kind = item.pKind;
      this.search.kindName = item.pName;
      this.stageList = item.pStage ? JSON.parse(item.pStage) : [];
      if (item.pKind == 1) this.stageList = this.stageList.filter((stage) => stage.name === "专升本");
      this.search.stage = item.pKind == 1 ? "1" : "全部";
      this.search.stageName = item.pKind == 1 ? "专升本" : "";
      this.search.zyId = "";
      this.search.zyName = "";
      this.search.kcId = "";
      this.search.kcName = "";
      const labels = await request({
        url: "/knowledgeManagement/fieldExtend/selectFieldExtendDetail", method: "GET",
        params: { kindId: item.pKind },
      });
      const fields = (labels.data || [])[0] || {};
      this.kindZyName = fields.zName || "全部专业";
      this.zStage = fields.zStage || "全部层次";
      await this.loadMajors();
      this.Kindzylist = this.zylist;
      this.getKc();
      this.getLIst();
    },
    loadMajors() {
      return homeClient.getMaterialsMajorDataList({
        ZKind: this.search.kind, zStage: this.search.stageName || undefined,
      }).then((res) => {
        this.zylist = (res.data || []).map((item) => ({
          ...item, zId: item.zid !== undefined ? item.zid : item.zId,
          zName: item.zname !== undefined ? item.zname : item.zName,
          zStage: item.zstage !== undefined ? item.zstage : item.zStage,
        }));
      });
    },
    async stageChoose(item) {
      this.search.stage = item ? item.stage : (this.search.kind == 1 ? "1" : "全部");
      this.search.stageName = item ? item.name : "";
      this.search.zyId = "";
      this.search.zyName = "";
      this.search.kcId = "";
      this.search.kcName = "";
      await this.loadMajors();
      this.getLIst();
    },
    zyChoose(item) {
      referenceFilter.methods.zyChoose.call(this, item ? {
        ...item, zid: item.zId,
      } : undefined);
      if (item && this.showKc) this.getKc();
    },
    getKc() {
      // 参照组件没有课程筛选请求，保留原课程接口及选择联动。
      const params = {};
      if (this.search.kind) params.kindId = this.search.kind;
      if (this.search.zyId) params.zId = this.search.zyId;
      return request({
        url: "/kecheng/docpackage/getDocPackageCourse", method: "GET", params,
      }).then((res) => {
        this.kcList = (res.data || []).map((item) => ({
          ...item, kid: item.id, keName: item.kcName,
        }));
      });
    },
    clas(item) {
      this.search.type = item ? item.fId : null;
      this.getLIst();
    },
  },
};
</script>
<style lang="less" scoped>
/* 高校合伙人 */
.entrantsType3 {
  .zychoice {
    width: 1200px !important;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin: 40px auto 24px;
    padding: 20px 32px 40px;

    .on {
      background: #f1f4ff !important;
      color: #4a6af0 !important;
    }
  }
}

.box-div {
  width: 100%;
  margin: 0px auto 0px;
}

.tui-img {
  width: 100%;
  height: 240px;
}

.zychoice {
  width: 100%;
  height: auto;
  box-shadow: 0px 0px 6px 0px rgba(216, 216, 216, 0.7);
  background: #ffffff;
  overflow: hidden;
  padding: 0px calc(50% - 610px) 32px;

  .zychoicePzion {
    width: 100%;
    background: #ffffff;
    height: 60px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-breadcrumb {
      font-size: 15px;
      cursor: pointer;
    }
  }

  .zychoiceTop {
    width: 100%;
    background: #ffffff;
    padding-top: 20px;
    // height: 70px;
    height: auto;
    // border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 30px;

    &:nth-child(1) {
      .right-item {
        font-size: 16px !important;
      }
    }

    .zychoiceTopLeft {
      flex-shrink: 0;
    }

    .zychoiceTopRight {
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;

      .right-item {
        height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        padding: 0px 16px;
        cursor: pointer;
      }

      .on {
        background: #f5f6f6;
        border-radius: 4px 4px 4px 4px;
        color: #ff5d51;
      }
    }
  }

  .zychoiceCen {
    width: 90%;
    height: 64px;
    margin: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .spana {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 53px;
      cursor: pointer;
    }

    .spanb {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 40px;
      cursor: pointer;
    }

    .spanbs {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ff4027;
      margin-right: 40px;
      cursor: pointer;
    }

    .spanc {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #27323f;
      margin-right: 30px;
      cursor: pointer;
    }

    .spancs {
      width: auto;
      height: auto;
      font-size: 15px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ff4027;
      margin-right: 30px;
      cursor: pointer;
    }
  }
}

.tabBox {
  width: 1220px;
  margin: auto;
  margin-top: 40px;

  .list {
    display: flex;

    .item {
      cursor: pointer;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 14px;

      .el-divider {
        margin: 0px 24px;
      }
    }

    .on {
      color: #ff5e51 !important;
    }
  }
}
</style>
